export const getTicketDisplayNumber = (ticket) => ticket?.ticketNumber || ticket?.id;

